import { http } from '@/app/lib/http/client'

export type SettingType =
    | 'string'
    | 'boolean'
    | 'integer'
    | 'decimal'
    | 'json'
    | 'color'
    | 'image'
    | 'timezone'

export interface ImageSettingValue {
    disk: string
    path: string
    url: string
    filename?: string
    mime_type?: string
    size?: number
}

export interface SettingItem<T = unknown> {
    key: string
    type: SettingType
    value: T | null
    is_public: boolean
    updated_at: string | null
}

export type SettingsPayload = Record<string, unknown>

export const settingsService = {
    async getSettings(): Promise<SettingItem[]> {
        const response = await http.get('/settings')
        return response.data.data
    },

    async getPublicSettings(sucursalId: number): Promise<SettingItem[]> {
        const response = await http.get('/settings/public', {
            params: { sucursal_id: sucursalId },
        })
        return response.data.data
    },

    async updateSettings(settings: SettingsPayload): Promise<SettingItem[]> {
        const response = await http.put('/settings', { settings })
        return response.data.data
    },

    async uploadAsset(key: string, file: File): Promise<SettingItem<ImageSettingValue>> {
        const formData = new FormData()
        formData.append('file', file)

        const response = await http.post(`/settings/assets/${encodeURIComponent(key)}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })

        return response.data.data
    },
}

export function settingsRecord(settings: SettingItem[]): Record<string, SettingItem> {
    return settings.reduce<Record<string, SettingItem>>((acc, setting) => {
        acc[setting.key] = setting
        return acc
    }, {})
}

export function settingValue<T>(settings: SettingItem[], key: string, fallback: T): T {
    const value = settings.find((setting) => setting.key === key)?.value
    return value === null || value === undefined ? fallback : (value as T)
}
